module.exports = __webpack_public_path__ + "img/bj-beaver.bcf35746.gif";